module.exports = __webpack_public_path__ + "img/ico_doutor.24605f9c.svg";